
<nz-tabs>
    @if(getOpenIncidentMessages().length > 0) {
      <nz-tab nzTitle="NO BREAKDOWN">
        <div class="clear-all-bar">
          <button nz-button nzType="default" nzDanger nzSize="small" (click)="clearAllOpenMessages()">
            <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
            Clear All
          </button>
        </div>
        @for (message of getOpenIncidentMessages(); track message.whatsappMessageId) {
            <app-wa-message [message]="message" (messageRemoved)="onMessageRemoved($event)"></app-wa-message>
        }    
      </nz-tab>
    }
    @if(getMessagesForIncident().length > 0) {
      <nz-tab nzTitle="{{getIncidentNumber()}}">

        @for (message of getMessagesForIncident(); track message.whatsappMessageId) {
            <app-wa-message [message]="message" (messageRemoved)="onMessageRemoved($event)"></app-wa-message>
        }
      </nz-tab>
    }

</nz-tabs>



